module.exports = __webpack_public_path__ + "static/media/photo120.aa64ac5b.jpg";